import {
  ChatEventFragment,
  ChatEventsQuery,
  ChatEventsQueryVariables,
  useChatEventsQuery,
  withRequiredVariables,
  withStandardListHook,
} from '@spotify/confidence-graphql';

export const useChatEvents = withStandardListHook<
  ChatEventsQuery,
  ChatEventFragment,
  'chatEvents',
  ChatEventsQueryVariables
>(withRequiredVariables(useChatEventsQuery), 'chatEvents');
